export default __webpack_public_path__ + "static/media/acredius.7d27f3a2.png";